import { AbstractControl, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';

export const urlRegex = /(^|\s)((https?:\/\/)?[\w-]+(\.[\w-]+)+\.?(:\d+)?(\/\S*)?)/;

export class SigningValidatorsUtil {
  static url(control: AbstractControl): ValidationErrors | null {
    if (!control.value) {
      return null;
    }

    if (!urlRegex.test(control.value as string)) {
      return { url: true };
    }

    return null;
  }

  static generateValidators(type: string): ValidatorFn[] {
    const validators = [Validators.required];
    switch (type) {
      case 'email':
        validators.push(Validators.email);
        break;
      case 'url':
        validators.push(SigningValidatorsUtil.url);
        break;
    }
    return validators;
  }
}
